import React from "react";
import { PathwayFormGroup, PathwayLabel, PathwayStyledInput } from "../../StyledComponents/PathwayForm";
import PropTypes from "prop-types";


const PathwaySingleFileInputGroup = (props) => {
    return (
        <PathwayFormGroup>
            {props.label && <PathwayLabel>{props.label}</PathwayLabel>}
            <PathwayStyledInput
                type="file"
                name={props.name}
                onChange={props.handleChange}
                disabled={props.disabled}
                data-cy={props.dataCy}
            />
        </PathwayFormGroup>
    );
};

export default PathwaySingleFileInputGroup;

PathwaySingleFileInputGroup.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    dataCy: PropTypes.string,
    invalidInputMessage: PropTypes.string,
    needsToBeFilled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    inputValidation: PropTypes.func,
    triggerOnBlur: PropTypes.func,
};
